import styled, { css } from "styled-components";

import { shadow, radius, motion, color } from "../../../styles/tokens";

/* The shared card surface. Four independent hover-lift implementations existed before this
 * (About feature cards, Facilities, Rooms, insights ArticleCard), each with its own shadow ramp and
 * its own translateY.
 *
 * The lift is a transform on hover only, and the global prefers-reduced-motion clamp in
 * global-css.js neutralises its transition for anyone who asked for less movement.
 */
const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: ${color.surface};
  border: 1px solid ${color.border};
  border-radius: ${radius.md};
  overflow: hidden;
  transition:
    transform ${motion.base},
    box-shadow ${motion.base},
    border-color ${motion.base};

  ${(props) =>
    props.$interactive
      ? css`
          &:hover {
            transform: translateY(-6px);
            box-shadow: ${shadow.lg};
            border-color: ${color.borderStrong};
          }

          &:focus-within {
            border-color: ${color.primary};
          }
        `
      : ""}
`;

export default Card;
